export enum HospitalNotifyConstants {
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT = 'hospitalNotify/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV = 'hospitalNotify/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV',
  SET_METHOD = 'hospitalNotify/SET_METHOD',
  SET_ALERT_TYPE = 'hospitalNotify/SET_ALERT_TYPE',
  SET_POTENTIAL_REGISTRY = 'hospitalNotify/SET_POTENTIAL_REGISTRY',
  SAVE_HOSPITAL_NOTIFY = 'hospitalNotify/SAVE_HOSPITAL_NOTIFY',
  RESET_STATE = 'hospitalNotify/RESET_STATE',
  SET_ADD_TO_TIMELINE = 'hospitalNotify/SET_ADD_TO_TIMELINE',
  SET_STATE = 'hospitalNotify/SET_STATE',
  SET_DATE_TIME = 'hospitalNotify/SET_DATE_TIME',
  SET_ASSESSED_BY = 'hospitalNotify/SET_ASSESSED_BY',
  ON_SELECT_HOSPITAL_NOTIFY = 'hospitalNotify/ON_SELECT_HOSPITAL_NOTIFY',
  SET_UPDATE_INPUT_ROWS = 'hospitalNotify/SET_UPDATE_INPUT_ROWS',
  SET_DATE = 'hospitalNotify/SET_DATE',
  SET_TIME = 'hospitalNotify/SET_TIME',
  SET_ATTEMPTS = 'hospitalNotify/SET_ATTEMPTS',
  SET_SUCCESSFUL_ATTEMPT = 'hospitalNotify/SET_SUCCESSFUL_ATTEMPT',
  SET_PTA = 'hospitalNotify/SET_PTA',
  SET_COMMENTS = 'hospitalNotify/SET_COMMENTS',
  SET_ROLE_PERFORMING = 'hospitalNotify/SET_ROLE_PERFORMING',
  SET_ROLE_PERFORMING_PNNV = 'hospitalNotify/SET_ROLE_PERFORMING_PNNV',
}
